import { useState } from "react";
import { Row, Col, Form, Container, FormGroup, Breadcrumb, Navbar, } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getDateWiseInvoiceReport } from "./Report.action";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import IconMenu from "../../../drawer/IconMenu";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import Swal from "sweetalert";


const DayWiseInvoiceReport = (props) => {
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);


  const handleDangerVisible = () => {
    setDangerVisibleAlert(true);
    setTimeout(() => {
      setDangerVisibleAlert(false);
    }, 9000);
    Swal({
      title: "Error",
      text: "Something went Wrong!",
      icon: "error",
      button: "Ok",
    });
  };
  const exportPDF = () => {
    props.getDateWiseDisReport({
      current_date: startDate
    },
      handleDangerVisible
    );
  };

  return (
    <>
      <div >
        <Navbar style={{ backgroundColor: '#81abd3' }}>
          <Container>
            <Navbar.Brand style={{ color: 'white' }}><b>Daily Invoice Report</b></Navbar.Brand>
            <IconMenu />
          </Container>
        </Navbar>
      </div>

      <Container fluid>
        <div className="main">
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item ><Link to="/home"> Home</Link></Breadcrumb.Item>
              <Breadcrumb.Item ><Link to="/report">Report</Link> </Breadcrumb.Item>
              <Breadcrumb.Item active>Daily Invoice Report</Breadcrumb.Item>
            </Breadcrumb>
          </Row>

          <Row>
            <Col>
              <FormGroup>
                <Form.Label><b>Date *</b></Form.Label>
                <Form.Control
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                ></Form.Control>
              </FormGroup>
            </Col>
          </Row>

          <div className="sendDiv">
            {_.isEmpty(startDate) ? (
              <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> Generate Report </Button>
            ) : (
              <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={() => exportPDF()}> Generate Report </Button>
            )}
          </div>

        </div>
      </Container>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDateWiseInvoiceReport: (data) => dispatch(getDateWiseInvoiceReport(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  isFetchingInvoiceReport: state.ReportReducer.isFetchingInvoiceReport,
  invoiceReportData: state.ReportReducer.invoiceReportData,
});

export default connect(mapStateToProps, mapDispatchToProps)(DayWiseInvoiceReport);